<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>

      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('platformCollection.name_of_collector')">
              <a-select
                v-model='queryParam.userName'
                optionFilterProp="children"
                showSearch
                allowClear
              >
                <a-select-option v-for='item in CollectorNameList' :key='item.value' :value='item.value'>
                  {{ item.key }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'催收员账号'">
              <a-input :placeholder="$t('enter') + ' 催收员账号'" v-model='queryParam.sysmobile'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='10' :sm='10'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'createTime')">
              <a-range-picker
                v-model='queryParam.endTime'
                format='YYYY-MM-DD'
                style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md='10' :sm='10'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'settleTime')">
              <a-range-picker
                v-model='queryParam.settleTime'
                format='YYYY-MM-DD'
                style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'overdueDaysStart')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.ORDER + 'overdueDays'))"
                       v-model='queryParam.overdueDaysStart'></a-input>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('platformCollection.department')">
              <a-select
                v-model='queryParam.departmentId'
                @change='onChangeOne'
                allowClear
              >
                <a-select-option v-for='item in departmentList' :key='item.id'>
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('platformCollection.grouping')">
              <a-select
                v-model='queryParam.groupId'
                allowClear
              >
                <a-select-option v-for='item in groupList' :key='item.id'>
                  {{ item.groupName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('platformCollection.collection_stage')">
              <a-select default-value='' style='width: 190px' v-model='queryParam.normalConfigId' allowClear>
                <a-select-option v-for='item in normalConfigList' :key='item.id'>
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('platformCollection.orderType')">
              <a-select
                default-value='0'
                style='width: 190px'
                v-model='queryParam.orderType'
                :options="[
                { value: '', label: '全部' },
                { value: '2', label: '正常订单&提前入催订单' },
                { value: '0', label: '正常订单' },
                { value: '-1', label: '提前入催订单' },
                { value: '1', label: '回捞订单' },
              ]"
              />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'用户类型'">
              <a-select default-value='' style='width: 120px' v-model='queryParam.loanCountFlag'>
                <a-select-option value=''>
                  全部
                </a-select-option>
                <a-select-option value='00'>
                  新户
                </a-select-option>
                <a-select-option value='01'>
                  老户
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('order.applicationDeadline')">
              <a-select  default-value='' style='width: 190px' v-model='queryParam.durations'>
                <a-select-option v-for='item in deadlineConfigList' :key='item.itemValue'>
                  {{ item.itemText }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
              <a-button type='primary' @click='downLoadData' icon='download'
                        style='margin-left: 8px'>{{ $t('exportFile') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>


      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        :footer='handleFooter'
        bordered>
        <template slot='userName' slot-scope='text, record,index'>
         <div style='width: 220px !important;'>{{record.userName}}</div>
        </template>
      </a-table>


    </div>
    <v-modal
      v-model='visible'
      :title="$t('order.collectionDetail')">
      <div style='padding: 20px;'>
        <collection-detail
          v-if='visible'
          :orderId='orderId'
          :custInfoId='custInfoId'
          :taskId='taskId'
          :auditDrawer='false'
          @close='visible = false;' />
      </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getCollectionPerformance, getSysGroup } from '@/webpublicapi/platformCollection'
import { getCollectionListDepartment } from '@/webpublicapi/group'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import vModal from '../modules/Modal'
import CollectionDetail from './CollectionDetail'
import { getAllNormalConfig } from '@/webpublicapi/normalConfig'
import { getAllDeadlineConfig } from '@/webpublicapi/deadlineConfig'
import exportFile from '@/webpublicapi/exportFile'
import { exportFileByPost } from '@/api/exportFile'
import { getCollectorName } from '@/webpublicapi/collection'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.'
}

export default {
  name: 'AllApprovalTask',
  components: {
    Dict,
    DictSelect,
    vModal,
    CollectionDetail
  },
  data() {
    return {
      CollectorNameList: [],
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      groupList: [],
      departmentList: [],
      normalConfigList: [],
      deadlineConfigList: [],
      // 查询条件
      queryParam: {
        endTime: [moment(), moment()],
        settleTime: [],
        userName: undefined,
        sysmobile: undefined,
        departmentId: undefined,
        groupId: undefined,
        normalConfigId: undefined,
        orderType: undefined,
        loanCountFlag: undefined,
        durations: undefined

      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '催收员账号',
          align: 'left',
          dataIndex: 'mobile'
        },
        {
          title: this.$t('collection.userName'),
          align: 'left',
          dataIndex: 'userName',
          width: 260,
          scopedSlots: { customRender: 'userName' }
        },
        {
          title: this.$t('collection.userId'),
          align: 'left',
          dataIndex: 'userId'
        },
        {
          title: this.$t('collection.groupName'),
          align: 'left',
          dataIndex: 'groupName'
        },
        {
          title: this.$t('collection.collectionNumber'),
          align: 'left',
          dataIndex: 'collectionNum'
        },
        {
          title: this.$t('collection.collectionAmount'),
          align: 'left',
          dataIndex: 'applyAmt'
        },
        // {
        //   title: this.$t('collection.collectionNumber'),
        //   align: 'left',
        //   dataIndex: 'collectionNum'
        // },
        {
          title: this.$t('collection.pendingNum'),
          align: 'left',
          dataIndex: 'pendingNum'
        },
        {
          title: this.$t('collection.processNum'),
          align: 'left',
          dataIndex: 'processNum'
        },
        {
          title: this.$t('collection.cancelNum'),
          align: 'left',
          dataIndex: 'cancelNum'
        },
        {
          title: this.$t('collection.succedNumber'),
          align: 'left',
          dataIndex: 'succedNum',
          defaultSortOrder: 'descend',
          sortDirections: ['descend', 'ascend'],
          sorter: (a, b) => this.succedNumsort(a, b)
        },
        {
          title: this.$t('collection.followCount'),
          align: 'left',
          dataIndex: 'followCount',
          defaultSortOrder: 'descend',
          sortDirections: ['descend', 'ascend'],
          sorter: (a, b) => this.followCountsort(a, b)
        },
        {
          title: this.$t('collection.extendNumber'),
          align: 'left',
          dataIndex: 'extendNum'
        },
        {
          title: this.$t('collection.succedAmount'),
          align: 'left',
          dataIndex: 'succedApplyAmt'
        },
        {
          title: this.$t('collection.succedRate'),
          align: 'left',
          dataIndex: 'succedRate',
          defaultSortOrder: 'descend',
          sortDirections: ['descend', 'ascend'],
          sorter: (a, b) => this.succedRatesort(a, b)
        },
        {
          title: this.$t('collection.amountSuccedRate'),
          align: 'left',
          dataIndex: 'amountSuccedRate'
        }
        // {
        //   title: '-',
        //   align: 'left',
        //   dataIndex: 'mark',
        //   customRender: function(text) {
        //     return {
        //       children: <span style='color: red;font-weight: bold'>{text}</span>
        //     }
        //   }
        // }
        // ,
        // {
        //   title:this.$t('collection.paymentamt'),
        //   align: 'left',
        //   dataIndex: 'paymentamt'
        // },
        // {
        //   title:this.$t('collection.naNum'),
        //   align: 'left',
        //   dataIndex: 'naNum'
        // }
      ]
    }
  },
  created() {
    this.getDict()
    // this.loadData();
    getSysGroup().then(res => {
      this.groupList = res.data || []
    })
    getCollectionListDepartment().then(res => {
      this.departmentList = res.data || []
    })
    getAllNormalConfig().then(res => {
      this.normalConfigList.push({
        'name': '全部',
        'id': '',
        'value': ''
      })
      res.data.forEach(item => {
        this.normalConfigList.push(item)
      })
    })
    getAllDeadlineConfig().then(res => {
      this.deadlineConfigList = res.data || []
    })
    //催收员名称
    getCollectorName().then(res => {
      console.log('res-->', res.data)
      let keys = Object.keys(res.data)
      for (const key of keys) {
        this.CollectorNameList.push({
          key: key,// s1test1
          value: res.data[key]
        })
      }
      console.log('催收员res--->this.CollectorNameList ', this.CollectorNameList)
    })
  },
  methods: {
    succedRatesort(a, b) {
      console.log('a--->', a)
      console.log('b--->', b)
      return a.succedRate - b.succedRate
    },
    succedNumsort(a, b) {
      console.log('a--->', a)
      console.log('b--->', b)
      return a.succedNum - b.succedNum
    },
    followCountsort(a, b) {
      console.log('a--->', a)
      console.log('b--->', b)
      return a.followCount - b.followCount
    },
    convertToTimestamp(dateString) {
      const dateObject = new Date(dateString)
      console.log('dateObject', dateObject.getTime())
      return dateObject.getTime()
    },
    addWithDecimalPlaces(num1, num2) {
      return (parseFloat(num1) + parseFloat(num2)).toFixed(2)
    },

    // 自定义的footer渲染函数
    handleFooter() {
      // 处理 width 成百分比, 默认 'auto' 会根据text 计算宽度，造成footer对不齐的情况
      const columns = this.columns
      columns.forEach(col => {
        col.width = (100 / columns.length) + '%'
      })
      let collectionNumFooter = 0
      let applyAmtFooter = 0
      let pendingNumFooter = 0
      let processNumFooter = 0
      let cancelNumFooter = 0
      let succedNumFooter = 0
      let followCountFooter = 0
      let extendNumFooter = 0
      let succedApplyAmtFooter = 0
      let succedRateFooter = 0
      let amountSuccedRateFooter = 0
      if (this.$refs.table && this.$refs.table.dataSource) {
        console.log(this.$refs.table.dataSource, 'refs.table')

        for (let item of this.$refs.table.dataSource) {
          console.log(Number(item.collectionNum), '--------', Number(collectionNumFooter))
          collectionNumFooter = Number(collectionNumFooter) + Number(item.collectionNum)
          applyAmtFooter = Number(applyAmtFooter) + Number(item.applyAmt ? item.applyAmt : 0)
          pendingNumFooter = Number(pendingNumFooter) + Number(item.pendingNum ? item.pendingNum : 0)
          processNumFooter = Number(processNumFooter) + Number(item.processNum ? item.processNum : 0)
          cancelNumFooter = Number(cancelNumFooter) + Number(item.cancelNum ? item.cancelNum : 0)
          succedNumFooter = Number(succedNumFooter) + Number(item.succedNum ? item.succedNum : 0)
          followCountFooter = Number(followCountFooter) + Number(item.followCount ? item.followCount : 0)
          extendNumFooter = Number(extendNumFooter) + Number(item.extendNum ? item.extendNum : 0)
          succedApplyAmtFooter = this.addWithDecimalPlaces(succedApplyAmtFooter, item.succedApplyAmt ? item.succedApplyAmt : 0)
          succedRateFooter = this.addWithDecimalPlaces(succedRateFooter, item.succedRate ? item.succedRate : 0)
          amountSuccedRateFooter = this.addWithDecimalPlaces(amountSuccedRateFooter, item.amountSuccedRate ? item.amountSuccedRate : 0)
        }

        console.log('succedRateFooter,', succedRateFooter)
        console.log(' this.$refs.table.dataSource.length', this.$refs.table.dataSource.length)
        if (succedRateFooter) {
          console.log(1111)
          succedRateFooter = (succedRateFooter / this.$refs.table.dataSource.length).toFixed(2)
        } else {
          console.log(22222)
          //被除数为0
        }
        console.log('succedRateFooters是啥', succedRateFooter)
        if(amountSuccedRateFooter){
          amountSuccedRateFooter = (amountSuccedRateFooter / this.$refs.table.dataSource.length).toFixed(2)
        }else {
          console.log(22222)
          //被除数为0
        }

      }
      let dataSourceFooter = []
      dataSourceFooter.push({
        mobile: '合计',
        userName: '',
        userId: '',
        groupName: '',
        collectionNum: collectionNumFooter,
        amountSuccedRate: amountSuccedRateFooter,
        applyAmt: applyAmtFooter,
        pendingNum: pendingNumFooter,
        processNum: processNumFooter,
        cancelNum: cancelNumFooter,
        succedNum: succedNumFooter,
        followCount: followCountFooter,
        extendNum: extendNumFooter,
        succedApplyAmt: succedApplyAmtFooter,
        succedRate: succedRateFooter
      })
      return (
        <a-table
          rowKey={Math.random}
          bordered={false}
          pagination={false}
          columns={columns}
          dataSource={dataSourceFooter || []}
          showHeader={false}
        ></a-table>
      )
    },
    CollectorNameListChange(e) {
      console.log('下拉框发生变化啦！', e)
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData()
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      // if (arg === 1) {
      //   this.form.pageNum = 1
      // }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      getCollectionPerformance(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          // this.total = res.data.total
          this.dataSource = res.data || []
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { endTime } = this.queryParam
      const { settleTime } = this.queryParam
      const data = {
        ...this.queryParam,
        endDateStart: (endTime && endTime.length) ? this.transformTime(endTime[0]) : undefined,
        endDateEnd: (endTime && endTime.length) ? this.transformTime(endTime[1]) : undefined,
        settleDateStart: (settleTime && settleTime.length) ? this.transformTime(settleTime[0]) : undefined,
        settleDateEnd: (settleTime && settleTime.length) ? this.transformTime(settleTime[1]) : undefined
      }
      delete data.settleTime
      delete data.endTime
      var param = Object.assign({}, data)
      // param.pageNum = this.form.pageNum;
      // param.pageSize = this.form.pageSize;
      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.endTime = [moment(), moment()]
      that.queryParam.settleTime = []
      that.queryParam.userName = undefined
      that.queryParam.sysmobile = undefined
      that.queryParam.departmentId = undefined
      that.queryParam.groupId = undefined
      that.queryParam.normalConfigId = undefined
      that.queryParam.orderType = undefined
      that.queryParam.loanCountFlag = undefined
      that.queryParam.durations = undefined

      //that.loadData(this.form.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
    onChangeOne(value) {
      console.log(value)
      getSysGroup({ 'departmentId': value }).then(res => {
        this.groupList = res.data || []
        this.queryParam.groupId = ''
      })
    },
    async downLoadData() {
      var params = this.getQueryParams()// 查询条件
      this.loading = true
      try {
        const result = await exportFileByPost(
          `/api/web/webpublic/platform/collectionTask/performanceExcel`,
          params,
          "催收绩效表.xlsx"
        );
        if (result instanceof Error) {
          this.$message.error(result.message);
        }
      } catch(error) {
          this.$message.error(error.message);
      } finally{
        this.loading = false
      }
    },

  //   downLoadData() {
  //     var params = this.getQueryParams()// 查询条件
  //     this.exportParams = Object.entries(params).map(([key, value]) => key + '=' + value) + ''
  //     const file = {
  //       fileUrl: '/api/web/webpublic/platform/collectionTask/performanceExcel?' + this.exportParams.replaceAll(',', '&'),
  //       fileName: '催收绩效表.xlsx'
  //     }
  //     // console.log(file.fileUrl)

  //     this.loading = true
  //     exportFile(file).catch(e => {
  //       this.$message.error(e.message)
  //     }).finally(() => {
  //       this.loading = false
  //     })
  //   }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
